module.exports = __webpack_public_path__ + "assets/media/send.ae1767bb.mp3";